module.exports = __webpack_public_path__ + "static/Sonyax4c-65b65bd0b11477ef62c46449730d7491.png";